<template>
  <div class="search-result-fields">
    <div v-for="(item, idx) in fieldList" :key="idx" class="field">
      <label class="field-label">{{ item }}</label>
      <Checkbox size="tiny" :checked="toggleFields.includes(item)" @change="onChange(item)" />
    </div>
  </div>
</template>

<script>
import Checkbox from '@/app/components/Checkbox.vue';

export default {
  components: {
    Checkbox
  },
  props: {
    fieldList: {
      type: Array,
      default: () => []
    },
    displayFields: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      toggleFields: [...this.displayFields]
    };
  },
  methods: {
    onChange(field) {
      let pos = this.toggleFields.indexOf(field);
      let emitFunc;
      if (pos >= 0) {
        this.toggleFields = this.toggleFields.filter(f => f !== field);
        emitFunc = 'removed';
      } else {
        this.toggleFields.push(field);
        emitFunc = 'selected';
      }
      this.$emit(emitFunc, { field });
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/app/styles/colors';
@import '@/app/styles/variables';
.search-result-fields {
  display: flex;
  flex-wrap: wrap;
  padding: 12px 5px;
  margin-left: auto;
  .field {
    .field-label {
      display: flex;
      align-items: center;
      display: inline-block;
      width: 250px;
    }
    &:nth-child(even) {
      margin-left: 10px;
    }
  }
}
</style>
